import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";

import { useSignUpForm } from "scenes/Authentication/hooks";

import { AgreementSection, CreateForm, Layout, Loading } from "./components";

export function SignUpForm({ email }) {
  const { signUp, error, loading } = useSignUpForm({ email });

  if (loading && !error) return <Loading active message="Signing up..." />;

  return (
    <Layout
      infoMessage={
        <div
          style={{
            fontSize: "1.2rem",
            textAlign: "center",
            marginTop: "-20px",
          }}
        >
          Starting a free trial is easy and takes only a few minutes
        </div>
      }
      errorMessage={error}
    >
      <CreateForm email={email} onSubmit={signUp} />
      <div
        style={{
          textAlign: "center",
          width: "100%",
          height: "40px",
          overflow: "auto",
        }}
      >
        <AgreementSection />
      </div>
      <div style={{ textAlign: "center", width: "100%", marginTop: "22px" }}>
        Already have a subscription? <Link to="/v2/login">Log in</Link>
      </div>
    </Layout>
  );
}

SignUpForm.propTypes = { email: PropTypes.string };
SignUpForm.defaultProps = { email: "" };

export default SignUpForm;
